import * as Sentry from "@sentry/vue";
import { API_ENDPOINTS } from "@utils/api/endpoints";

export default async function (id, body) {
  try {
    return await $apiFetch(API_ENDPOINTS.NOTIFICATION_FCM_ID_CONFIRM, {
      method: 'PUT',
      path: { id },
      body
    });
  } catch (error) {
    Sentry.captureException(error);
  }

  return null;
}
